<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { computed } from 'vue';
import Banner from '@/components/shared/Banner.vue';
import PolicyLookup from '@/components/shared/PolicyLookup.vue';
import { useReferenceStore } from '@/stores/reference';
import { SchoolType } from '@sas/shared/constants';

useHead({
  title: 'K-12 Student Insurance | Student Assurance Services',
  meta: [
    {
      name: 'description',
      content:
        'Accident insurance coverage for K-12 students including enrollment, claims, and policy information.',
    },
  ],
});

/// Data
const store = useReferenceStore();

/// Computed
const states = computed(() => store.statesFor(SchoolType.K12));
</script>

<template>
  <Banner image="k12" alt="K-12 students">
    <h1>K12 Students<br />&amp; Parents</h1>
  </Banner>
  <div class="container-sm flex flex-col gap-30 py-48">
    <p class="md:text-17">
      As a service to the community, your school has contracted with us to offer or administer an
      accident insurance plan for your student. This is a valuable option to parents/guardians who,
      because of various reasons, do not have health insurance. It is also an excellent way to
      supplement your health insurance if your plan has a large deductible, copay, or coinsurance,
      including HSA plans.
    </p>
    <p class="md:text-17">
      Use the school finder below to find information regarding your school's student accident
      insurance plan. You may: view and download the plan brochure and enrollment form (if
      applicable); enroll online; or download a claim form to complete.
    </p>
    <p class="md:text-17">
      Please use <RouterLink to="/aboutus/requestinfo">Information Request</RouterLink> form to
      request any additional information.
    </p>
    <PolicyLookup :type="SchoolType.K12" :state-list="states" />
  </div>
</template>
